import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { iconScalableStyles } from "@store/Themes/common/mixins/icon";
import { css } from "styled-components";

export type StatusColor = "success" | "warning" | "danger" | "info" | "neutral";

export const statusStyles = (color?: StatusColor) => {
    return css`
        display: flex;
        align-items: center;
        padding: ${pxToRem(6, 15)};
        border-radius: ${pxToRem(4)};

        ${({ theme }) => css`
            color: ${getColor(color)};
            background-color: ${getColor(`${color}.light`)};
            font-size: ${theme.design.typography.size.smaller};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.semi};
        `}

        ${IconWrapper} {
            ${iconScalableStyles(pxToRem(18))}
            margin: ${pxToRem(0, 5, 0, -1)};
        }
    `;
};
